"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("../state/state"));
exports.default = (function (target) {
    if (target.type === 'number') {
        var category_1 = target.id.replace('selected-', '').replace(/[0-9]+/, '');
        var title = state_1.default.selectedItem.filter(function (item) { return item.id.replace(/[0-9]+/, '') === category_1; }).map(function (item) { return item.name; }).join(', ');
        var $targetNameTitle_1 = document.querySelector(".".concat(category_1, "__title"));
        var $targetNameModalTitle_1 = document.querySelector(".menu__".concat(category_1, " > .modal > div"));
        $targetNameTitle_1.innerHTML = title === '' ? '선택하세요<i class="fas fa-sort-down"></i>' : title;
        $targetNameModalTitle_1.innerHTML = title === '' ? '선택하세요<i class="fas fa-sort-down"></i>' : title;
        return;
    }
    var $targetNameTitle = document.querySelector(".".concat(target.name, "__title"));
    var $targetNameModalTitle = document.querySelector(".menu__".concat(target.name, " > .modal > div"));
    var name = state_1.default.selectedItem.filter(function (item) { return item.id.replace(/[0-9]+/, '') === target.name; }).map(function (item) { return item.name; }).join(', ');
    if (target.matches('#size1') || target.matches('#size2')) {
        $targetNameTitle.textContent = state_1.default.sizeState.name;
        $targetNameModalTitle.textContent = state_1.default.sizeState.name;
        return;
    }
    else if (target.type === 'checkbox' || target.type === 'radio') {
        $targetNameTitle.innerHTML = name === '' ? '선택하세요<i class="fas fa-sort-down"></i>' : name;
        $targetNameModalTitle.innerHTML = name === '' ? '선택하세요<i class="fas fa-sort-down"></i>' : name;
    }
    else
        return;
});
